export default __webpack_public_path__ + "static/media/afp.f8fda29a.svg";